export const COACH_ROLES = ["SleepCoach", "ComplianceCoach"];
export const COACH_EDITABLE_STATUSES = ["New", "Coach Follow Up"];

const ADMIN_ROLES = [
  "Administrator",
  "CompanyAdministrator",
  "OfficeAdministrator",
  "ServiceAdmin",
  "ServiceCoach",
  "ContractorAdministrator"
];
const ADMIN_BLOCKED_QUANTITY_STATUSES = [
  "Completed",
  "Accepted",
  "Billed",
  "Voided",
  "Rejected"
];

export const canEditOrder = (userRole, orderStatus) => {
  if (!COACH_ROLES.includes(userRole)) return true;
  return COACH_EDITABLE_STATUSES.includes(orderStatus);
};

export const canChangeLineItemQuantities = (userRole, orderStatus) => {
  if (ADMIN_ROLES.includes(userRole)) {
    return !ADMIN_BLOCKED_QUANTITY_STATUSES.includes(orderStatus);
  }
  return COACH_EDITABLE_STATUSES.includes(orderStatus);
};
